
<script>
import timefield from './js'
export default timefield
</script>

<style scoped>
@import './scss/timefield.scss';
</style>
